import bugsnag from '@bugsnag/js';

import {
  BUGSNAG_ERROR_CLASSES,
  BUGSNAG_GRAPHQL_IGNORED_OPERATIONS,
  BUGSNAG_NETWORK_IGNORED_OPERATIONS,
} from 'utils/constants';

const getGraphqlErrorMetadata = ({ operation, response }) => ({
  GraphQL_Response: response,
  GraphQL_Request: operation,
});

export const notifyError = ({
  errorClass = BUGSNAG_ERROR_CLASSES.DEFAULT_ERROR,
  message,
  severity,
  metadata = {},
}) => {
  const error = {
    name: errorClass,
    message,
  };

  bugsnag.notify(error, (event) => {
    event.severity = severity;
    event.groupingHash = errorClass;
    for (const metaKey of Object.keys(metadata)) {
      event.addMetadata(metaKey, metadata[metaKey]);
    }
  });
};

export const notifySpinnerTimeout = (timeout) => {
  notifyError({
    errorClass: BUGSNAG_ERROR_CLASSES.SPINNER_TIMEOUT,
    message: `${timeout}s limit was reached`,
    severity: 'warning',
  });
};

export const notifyGraphqlError = (graphqlError) => {
  const { graphQLErrors, networkError, operation } = graphqlError;

  if (operation.query) {
    operation.query = operation.query.loc.source.body;
  }

  const customMessage = operation.operationName + ' Error';

  if (
    !BUGSNAG_GRAPHQL_IGNORED_OPERATIONS.includes(operation.operationName) &&
    graphQLErrors
  ) {
    notifyError({
      errorClass: BUGSNAG_ERROR_CLASSES.GRAPHQL_ERROR,
      message: customMessage,
      severity: 'warning',
      metadata: getGraphqlErrorMetadata(graphqlError),
    });
  }

  if (
    !BUGSNAG_NETWORK_IGNORED_OPERATIONS.includes(operation.operationName) &&
    networkError
  ) {
    notifyError({
      errorClass: BUGSNAG_ERROR_CLASSES.GRAPHQL_NETWORK_ERROR,
      message: customMessage,
      severity: 'warning',
      metadata: {
        GraphQL_Network_Error: networkError,
        GraphQL_Request: operation,
      },
    });
  }
};

export const notifyNoAccess = (authData) => {
  const { isAuthenticated, eCommerceAccess } = authData;

  let customMessage = '';

  if (!isAuthenticated) {
    customMessage = BUGSNAG_ERROR_CLASSES.USER_UNAUTHORIZED;
  } else if (!eCommerceAccess.length) {
    customMessage = BUGSNAG_ERROR_CLASSES.USER_WITHOUT_ACCESSES;
  } else {
    customMessage = BUGSNAG_ERROR_CLASSES.USER_WITHOUT_PROPER_ACCESS;
  }

  notifyError({
    errorClass: BUGSNAG_ERROR_CLASSES.USER_ERROR,
    message: customMessage,
    severity: 'info',
  });
};

export const notifyInvalidBillToAddress = (graphqlError = {}) => {
  notifyError({
    errorClass: BUGSNAG_ERROR_CLASSES.USER_ERROR,
    message: 'User without Bill To Address',
    severity: 'warning',
    metadata: getGraphqlErrorMetadata(graphqlError),
  });
};

export const notifyUnhandledLookupStatus = (status, lookupResults) => {
  notifyError({
    message: `Unhandled Lookup Status: ${status}`,
    severity: 'warning',
    metadata: {
      Lookup_Results: lookupResults,
    },
  });
};

export const notifyCaseSubmitted = (caseData) => {
  notifyError({
    errorClass: BUGSNAG_ERROR_CLASSES.CASE_CREATED,
    message: `Case Created`,
    severity: 'info',
    metadata: {
      Case: caseData,
    },
  });
};

export const notifyCommerceIncomplete = () => {
  notifyError({
    errorClass: BUGSNAG_ERROR_CLASSES.USER_ERROR,
    message: `Commerce incomplete account`,
    severity: 'warning',
  });
};
